import { styled } from '@linaria/react'
import React, { type FC, type PropsWithChildren, type ReactNode } from 'react'
import { FetchingError } from '../components/FetchingError'
import { Loader } from '../ui/Loader'
import { Rhytm } from '../ui/Rhytm'
import { TitleAndSubtitle } from '../ui/TitleAndSubtitle'

export const BoxesLayout: FC<
  {
    titleElement: ReactNode | null
    subtitleElement?: ReactNode
    tabsElement: ReactNode
    loading: boolean
    error: boolean
    onRetryFetch: VoidFunction
    className?: string
  } & PropsWithChildren
> = ({
  titleElement,
  subtitleElement,
  tabsElement,
  children,
  loading,
  error,
  onRetryFetch,
  className,
}) => {
  return (
    <BoxesLayoutContainer className={className}>
      {Boolean(titleElement) && (
        <TitleAndSubtitle
          title={titleElement}
          subtitle={subtitleElement}
          titleFontSize={24}
        />
      )}
      {(() => {
        if (error) {
          return <FetchingError onRetry={onRetryFetch} />
        }

        if (loading) {
          return (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          )
        }

        return (
          <Rhytm>
            {tabsElement}
            {children}
          </Rhytm>
        )
      })()}
    </BoxesLayoutContainer>
  )
}

const BoxesLayoutContainer = styled.div`
  height: 100%;
  flex-grow: 1;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 20px; // Для красоты
  flex: 1;
  min-height: 0;
`

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex: 1;
`
